import createRoute        from '@widesk-ui/tools/createRoute';
import ParticipationModel from '@models/website/ParticipationModel';

const route = createRoute.splitView(
	'/website_entertainments/:websiteEntertainmentId/participations',
	'website',
	'ParticipationSplitView',
	ParticipationModel.localize('plural'),
);
export default route;
